import React from 'react';
import { Navigate } from 'react-router';

/**
 * @param {object} params
 * @param {string} params.to
 * @returns {React.ReactNode}
 */
export const NavigateWithRedirect = ({ to }) => {
  const currentPath = window.location.pathname;

  if (currentPath === '/') {
    return <Navigate replace to={to} />;
  }

  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('redirect', currentPath);

  return <Navigate replace to={`${to}?${searchParams.toString()}`} />;
};
